export enum ListType {
  Static = 'static',
  Dynamic = 'dynamic',
  Dinamic = 'dinamic',
  Dimanic = 'dimanic'
}
